import { c as _c } from "react/compiler-runtime";
// IInput.tsx
import React, { forwardRef } from "react";
import { IInputProps } from "@/app/components/Common/Input/input.interface";
import inputStyle from "@/app/components/Common/Input/input.style";
import CurrencyInput from "react-currency-input-field";
import cn from "@/app/utils/cn";
import changeNumToEng from "@/app/utils/persianNumToEnglish";
const IInput = forwardRef<HTMLInputElement, IInputProps>((t0, ref) => {
  const $ = _c(73);
  const {
    autoFocus,
    label,
    labelStyle,
    containerCustomStyle,
    inputId,
    prefix: t1,
    type: t2,
    value: t3,
    suffix: t4,
    onChange: t5,
    style: t6,
    customInputClass,
    placeholder: t7,
    helper,
    decimalsLimit: t8,
    maxLength,
    onKeyDown,
    readOnly,
    disabled,
    hasMaxValue: t9,
    maxValueHandler,
    customFieldClassName,
    autoComplete,
    inputMode,
    maxClassname,
    dir,
    suffixClass: t10,
    hasError: t11,
    error,
    clickHandler,
    hasSuffixClick,
    suffixClickHandler,
    onFocus,
    handleFocus,
    handleClickSelectAll,
    pattern,
    onkeypress,
    helperClass,
    onBlur,
    prefixClassName
  } = t0;
  const prefix = t1 === undefined ? null : t1;
  const type = t2 === undefined ? "text" : t2;
  const value = t3 === undefined ? "" : t3;
  const suffix = t4 === undefined ? null : t4;
  const onChange = t5 === undefined ? _temp : t5;
  const style = t6 === undefined ? "secondaryOutline" : t6;
  const placeholder = t7 === undefined ? "" : t7;
  const decimalsLimit = t8 === undefined ? 0 : t8;
  const hasMaxValue = t9 === undefined ? false : t9;
  const suffixClass = t10 === undefined ? "" : t10;
  t11 === undefined ? false : t11;
  let t12;
  if ($[0] !== onChange) {
    t12 = e => {
      onChange(e);
    };
    $[0] = onChange;
    $[1] = t12;
  } else {
    t12 = $[1];
  }
  const handleInputChange = t12;
  let t13;
  if ($[2] !== decimalsLimit) {
    t13 = function transformTEngilsh(rawVaule) {
      const localeDecimalSeparators = /[\u066B\u066C\uFF0E\uFF0C\u060C]/g;
      const value_0 = changeNumToEng(rawVaule).replace(/['’`\s\u00A0\u202F_]/g, "");
      if (decimalsLimit === 0) {
        return value_0.replace(/[.,\u066B\u066C\uFF0E\uFF0C\u060C]/g, "");
      }
      const separators = [...value_0.matchAll(localeDecimalSeparators)];
      const decimalIndex = separators.at(-1)?.index;
      if (decimalIndex === undefined) {
        return value_0;
      }
      return [...value_0].reduce((normalized, char, index) => {
        if (!/[\u066B\u066C\uFF0E\uFF0C\u060C]/.test(char)) {
          return normalized + char;
        }
        return index === decimalIndex ? `${normalized}.` : normalized;
      }, "");
    };
    $[2] = decimalsLimit;
    $[3] = t13;
  } else {
    t13 = $[3];
  }
  const transformTEngilsh = t13;
  let t14;
  if ($[4] !== hasSuffixClick || $[5] !== suffixClickHandler) {
    t14 = e_0 => {
      e_0.preventDefault();
      if (hasSuffixClick) {
        suffixClickHandler && suffixClickHandler(e_0);
      }
    };
    $[4] = hasSuffixClick;
    $[5] = suffixClickHandler;
    $[6] = t14;
  } else {
    t14 = $[6];
  }
  const clickSuffix = t14;
  let t15;
  if ($[7] !== containerCustomStyle) {
    t15 = cn(containerCustomStyle, "relative");
    $[7] = containerCustomStyle;
    $[8] = t15;
  } else {
    t15 = $[8];
  }
  let t16;
  if ($[9] !== inputId || $[10] !== label || $[11] !== labelStyle) {
    t16 = label && <label className={cn(labelStyle ? labelStyle : "", "text-sm font-semibold text-charcoal-900")} htmlFor={inputId}>{label}</label>;
    $[9] = inputId;
    $[10] = label;
    $[11] = labelStyle;
    $[12] = t16;
  } else {
    t16 = $[12];
  }
  const t17 = (inputStyle as any)[style];
  let t18;
  if ($[13] !== customInputClass || $[14] !== t17) {
    t18 = cn(inputStyle.inputContainer, t17, customInputClass);
    $[13] = customInputClass;
    $[14] = t17;
    $[15] = t18;
  } else {
    t18 = $[15];
  }
  let t19;
  if ($[16] !== prefix || $[17] !== prefixClassName) {
    t19 = prefix && <span className={cn("h-full", prefixClassName)}>{prefix}</span>;
    $[16] = prefix;
    $[17] = prefixClassName;
    $[18] = t19;
  } else {
    t19 = $[18];
  }
  let t20;
  if ($[19] !== autoComplete || $[20] !== autoFocus || $[21] !== clickHandler || $[22] !== customFieldClassName || $[23] !== decimalsLimit || $[24] !== dir || $[25] !== disabled || $[26] !== handleClickSelectAll || $[27] !== handleFocus || $[28] !== handleInputChange || $[29] !== hasMaxValue || $[30] !== inputId || $[31] !== inputMode || $[32] !== maxClassname || $[33] !== maxLength || $[34] !== maxValueHandler || $[35] !== onBlur || $[36] !== onFocus || $[37] !== onKeyDown || $[38] !== onkeypress || $[39] !== pattern || $[40] !== placeholder || $[41] !== readOnly || $[42] !== ref || $[43] !== transformTEngilsh || $[44] !== type || $[45] !== value) {
    t20 = type !== "currency" ? <><input autoComplete={autoComplete ? autoComplete : "off"} aria-autocomplete="none" autoFocus={!!autoFocus} ref={ref} id={inputId} inputMode={inputMode} onKeyDown={onKeyDown} onKeyPress={onkeypress} type={type === "floatNumber" ? "number" : type} step={type === "floatNumber" ? "0.01" : "any"} dir={dir ? dir : type === "number" ? "ltr" : ""} placeholder={placeholder} value={value} readOnly={readOnly} maxLength={maxLength} disabled={disabled} onChange={handleInputChange} onBlur={onBlur} onFocus={e_1 => {
        handleFocus?.(e_1);
        onFocus?.();
      }} onClick={clickHandler} pattern={pattern} className={cn("bg-aquamarine-300 relative h-full w-full flex-1 appearance-none bg-transparent px-1 text-start text-base font-bold outline-none placeholder:text-sm placeholder:font-normal placeholder:text-charcoal-600", customFieldClassName)} />{hasMaxValue ? <button type="button" onClick={maxValueHandler} className="mx-4 border-l border-l-charcoal-600 px-4 text-sm font-medium text-bluetiful-400">MAX</button> : ""}</> : <><CurrencyInput transformRawValue={transformTEngilsh} id={inputId} aria-autocomplete="none" autoComplete="off" name="currencyInput" onKeyDown={onKeyDown} className={cn("relative h-full w-full flex-1 appearance-none bg-transparent px-1 text-base font-bold outline-none placeholder:text-sm placeholder:font-normal placeholder:text-charcoal-600", customFieldClassName)} dir="ltr" placeholder={placeholder} decimalsLimit={decimalsLimit} decimalSeparator="." groupSeparator="," value={value === "" || value === null || value === undefined ? null : value} onValueChange={handleInputChange} onFocus={e_2 => {
        handleFocus?.(e_2);
        onFocus?.();
      }} onBlur={onBlur} onClick={handleClickSelectAll} ref={ref} />{hasMaxValue && <button type="button" onClick={maxValueHandler} className={`mx-4 border-l border-l-charcoal-600 px-4 text-sm font-medium text-bluetiful-400 ${maxClassname}`}>MAX</button>}</>;
    $[19] = autoComplete;
    $[20] = autoFocus;
    $[21] = clickHandler;
    $[22] = customFieldClassName;
    $[23] = decimalsLimit;
    $[24] = dir;
    $[25] = disabled;
    $[26] = handleClickSelectAll;
    $[27] = handleFocus;
    $[28] = handleInputChange;
    $[29] = hasMaxValue;
    $[30] = inputId;
    $[31] = inputMode;
    $[32] = maxClassname;
    $[33] = maxLength;
    $[34] = maxValueHandler;
    $[35] = onBlur;
    $[36] = onFocus;
    $[37] = onKeyDown;
    $[38] = onkeypress;
    $[39] = pattern;
    $[40] = placeholder;
    $[41] = readOnly;
    $[42] = ref;
    $[43] = transformTEngilsh;
    $[44] = type;
    $[45] = value;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  let t21;
  if ($[47] !== suffixClass) {
    t21 = cn("h-full text-2xl", suffixClass);
    $[47] = suffixClass;
    $[48] = t21;
  } else {
    t21 = $[48];
  }
  let t22;
  if ($[49] !== clickSuffix || $[50] !== suffix || $[51] !== t21) {
    t22 = <span className={t21} onClick={clickSuffix}>{suffix}</span>;
    $[49] = clickSuffix;
    $[50] = suffix;
    $[51] = t21;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  let t23;
  if ($[53] !== t18 || $[54] !== t19 || $[55] !== t20 || $[56] !== t22) {
    t23 = <div className={t18}>{t19}{t20}{t22}</div>;
    $[53] = t18;
    $[54] = t19;
    $[55] = t20;
    $[56] = t22;
    $[57] = t23;
  } else {
    t23 = $[57];
  }
  let t24;
  if ($[58] !== helperClass) {
    t24 = cn("rtl text-xs", helperClass);
    $[58] = helperClass;
    $[59] = t24;
  } else {
    t24 = $[59];
  }
  let t25;
  if ($[60] !== helper || $[61] !== t24) {
    t25 = <span className={t24}>{helper}</span>;
    $[60] = helper;
    $[61] = t24;
    $[62] = t25;
  } else {
    t25 = $[62];
  }
  let t26;
  if ($[63] !== error) {
    t26 = error && <p className="mt-1 text-xs leading-4 text-rojo-400">{error}</p>;
    $[63] = error;
    $[64] = t26;
  } else {
    t26 = $[64];
  }
  let t27;
  if ($[65] !== t23 || $[66] !== t25 || $[67] !== t26) {
    t27 = <div>{t23}{t25}{t26}</div>;
    $[65] = t23;
    $[66] = t25;
    $[67] = t26;
    $[68] = t27;
  } else {
    t27 = $[68];
  }
  let t28;
  if ($[69] !== t15 || $[70] !== t16 || $[71] !== t27) {
    t28 = <div className={t15}>{t16}{t27}</div>;
    $[69] = t15;
    $[70] = t16;
    $[71] = t27;
    $[72] = t28;
  } else {
    t28 = $[72];
  }
  return t28;
});
IInput.displayName = "IInput";
export default IInput;
function _temp() {}